import { atomWithStorage } from 'sierra-client/state/storage'
import { EditableContentFilter } from 'sierra-domain/api/author-v2'

export const recentlyEditedSettingAtom = atomWithStorage<EditableContentFilter>(
  'create-page-recently-edited',
  'anyone'
)
